"use client";

import React from "react";
import { DoorOpen, AppWindow, Hammer, CloudRain, ShieldCheck, Clock } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "השגחה סיעודית בבית",
  description: "ליווי צמוד ומקצועי של מטפל סיעודי בבית המטופל, תוך שמירה על שגרת חיים מכבדת וביטחון אישי מלא.",
  icon: DoorOpen
}, {
  title: "ליווי לאחר אשפוז",
  description: "סיוע בתהליך ההחלמה לאחר ניתוח או אשפוז ממושך, כולל עזרה בניידות, רחצה וניהול תרופות.",
  icon: AppWindow
}, {
  title: "טיפול סיעודי בבית חולים",
  description: "שירותי השגחה פרטית בבתי חולים כדי להבטיח שהיקיר לכם לעולם לא יישאר לבד במהלך הלילה או היום.",
  icon: Hammer
}, {
  title: "סיוע בפעולות יומיומיות",
  description: "עזרה מקצועית ברחצה, הלבשה, האכלה וניידות, המוענקת ברגישות ובחמלה על ידי צוות מיומן.",
  icon: CloudRain
}, {
  title: "התאמת מטפל אישי",
  description: "תהליך התאמה קפדני בין המטופל למטפל, תוך התחשבות בשפה, רקע תרבותי וצרכים רפואיים ספציפיים.",
  icon: ShieldCheck
}, {
  title: "מענה מיידי 24/7",
  description: "זמינות מלאה לכל צורך דחוף. אנחנו מתחייבים למציאת פתרון סיעודי איכותי בתוך 5 שעות בלבד.",
  icon: Clock
}];
export default function SpecializedServicesGrid() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="256977" id="שירותים-סיעודיים" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-[var(--max-content-width)]">
        
        {}
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto mb-12 md:mb-16 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="text-primary font-semibold tracking-wider uppercase text-sm block mb-3 font-default">
            השירותים שלנו
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 font-default">
            פתרונות סיעוד מותאמים אישית
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            אנחנו כאן כדי להעניק לכם שקט נפשי וטיפול מקצועי, בדיוק כשאתם זקוקים לו ביותר.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => {
          const cardReveal = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={i} data-index={i} ref={cardReveal.ref} className={`transition-all duration-700 ease-out delay-[${i * 100}ms] ${cardReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full border-none shadow-md hover:shadow-lg transition-shadow duration-300 bg-card rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-lg bg-accent flex items-center justify-center mb-4">
                      <service.icon className="w-6 h-6 text-primary" />
                    </div>
                    <CardTitle className="text-xl font-default text-card-foreground">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed font-default">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

      </div>
    </section>;
}